<script setup lang="ts">
// https://icon-sets.iconify.design/

// SUCCESS
// import IconAccessibility from "~icons/carbon/accessibility";
// <icon-accessibility />
// import IconAccountBox from "~icons/mdi/account-box";
// <icon-account-box style="font-size: 2em; color: red" />

// import { ChevronUpDownIcon } from "@heroicons/vue/24/solid";

// UNSUCCESS : 使用 unplugin-icons 和 unplugin-auto-import 从 iconify 中自动导入任何图标集
// in Vite
// pnpm i unplugin-icons --save-dev
// pnpm i unplugin-vue-component --save-dev
// pnpm i @iconify/json --save-dev
// pnpm i @iconify-json/mdi --save-dev
// <icon-carbon-accessibility />
// <icon-mdi-account-box style="font-size: 2em; color: red" />

import { ref, watchEffect } from "vue";
import { Icon } from "@iconify/vue";
import { mapState } from "../../context/context";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    icon?: string;
    color?: string;
  }>(),
  { icon: "mdi-light:home" }
);

const mappedState = mapState(["color.primaryPattern"]);

const color = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.primaryPattern"].value;
});
</script>

<template>
  <span
    class="icon"
    :style="[
      'display: inline-flex',
      'justify-content: center',
      'align-items: center',
      'cursor: pointer',
      'font-size: 1em',
      'color: ' + color
    ]"
  >
    <Icon
      :icon="props.icon"
      :color="color"
    />
  </span>
</template>

<style scoped></style>
